import React, { useState, useEffect } from 'react';

const StatusFilterLegend = ({ data, onFilterChange }) => {
   const statuses = [
     { label: 'Added', color: '#90EE90' },
     { label: 'Updated', color: '#87CEFA' },
     { label: 'Deleted', color: '#FFB6C6' },
     { label: 'Added/Updated', color: '#FFFF00' },
     { label: 'Added/Updated/Deleted', color: '#D3D3D3' },
     { label: 'Added/Deleted', color: '#FFA500' },
     { label: 'Updated/Deleted', color: '#DDA0DD' }
   ];

  const [checkedStatuses, setCheckedStatuses] = useState(
    statuses.reduce((acc, status) => ({ ...acc, [status.color]: true }), {})
  );

  const handleCheckboxChange = (color) => {
    setCheckedStatuses(prev => ({
      ...prev,
      [color]: !prev[color]
    }));
  };

  useEffect(() => {
    if (data) {
      const filteredData = data.filter(item => {
        return checkedStatuses[item.background_color] ?? true;
      });      
      onFilterChange(filteredData);
    }
  }, [checkedStatuses, data]);

  return (
    <div style={{
      display: "flex",
      alignItems: "flex-end",
      flexWrap: "wrap",
      gap: "12px",
      fontSize: "13px",
    }}>
      {statuses.map((status, index) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }} key={index}>
          <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={checkedStatuses[status.color]}
              style={{
                appearance: "none",
                width: "16px",
                height: "16px",
                borderRadius: "4px",
                backgroundColor: status.color,
                cursor: "pointer",
                outline: "none",
                border: "1px solid rgba(0,0,0,0.1)",
                margin: 0,
              }}
              onChange={() => handleCheckboxChange(status.color)}
            />
            {checkedStatuses[status.color] && (
              <i 
                className="bx bx-check"
                style={{
                  position: 'absolute',
                  left: '1px',
                  top: '1px',
                  fontSize: '14px',
                  pointerEvents: 'none',
                  color: 'rgba(0,0,0,0.6)',
                }}
              />
            )}
          </div>
          <span>{status.label}</span>
        </div>
      ))}
    </div>
  );
};

export default StatusFilterLegend;